<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useUser } from '~/stores/user'

const props = defineProps<{
  link: string
  loading: boolean
}>()

const model = defineModel<boolean>()

const { isLoggedIn } = storeToRefs(useUser())

const { t } = useI18n()
const emit = defineEmits(['close'])
const toast = useToast()
const clipboard = useClipboard()

function copyLink() {
  clipboard.copy(props.link)
  toast.add({
    title: t('configurator.share.linkCopied'),
  })
}
</script>

<template>
  <UiModal
    v-model="model"
    panel-classes="bg-white max-w-md"
    @close="emit('close')"
  >
    <div class="flex flex-col gap-2">
      <p class="text-pragmatica-extended mb-2 text-4xl font-bold">
        {{ t('configurator.share.name') }}
      </p>
      <div v-if="loading" class="mx-auto mb-2">
        <Icon
          name="line-md:loading-twotone-loop"
          class="h-10 w-10 text-black"
        />
      </div>
      <template v-else>
        <p v-if="isLoggedIn">{{ t('configurator.share.shareLink') }}</p>
        <NuxtLink
          class="mb-2 break-all underline"
          :to="link"
          external
          target="_blank"
        >
          {{ link }}
        </NuxtLink>
      </template>
      <button
        class="text-pragmatica-extended mx-auto w-fit rounded-2xl bg-black px-3 py-2 font-bold text-white"
        :disabled="loading || link === ''"
        :class="{
          'bg-neutral-300': loading || link === '',
        }"
        @click="copyLink()"
      >
        {{ t('configurator.share.copyLink') }}
      </button>
    </div>
  </UiModal>
</template>
